export default {
  base: {// color: 'uswitch-navy',
  },
  th: {
    base: {
      color: 'white',
      backgroundColor: 'black'
    }
  }
};